package com.zq.webproject.network.model

/**
 * Author: $
 * Date: $
 * Description: $商品分类数据类
 */
import kotlinx.serialization.Serializable

@Serializable
data class Category(
    val id: Int,
    val name: String,
    val parentId: Int,
    val level: Int,
    val sort: Int
)

@Serializable
data class CategoryResponse(
    val code: Int,
    val message:String,
    val data: List<Category>
)